module.exports = __webpack_public_path__ + "img/news05.298a65a.png";